import { useState, useEffect } from 'react';

/**
 * Custom hook to get current window dimensions
 * Updates on window resize for responsive design
 */
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

/**
 * Predefined breakpoints matching common device sizes
 */
export const breakpoints = {
  mobile: 576,      // ≤575px: Mobile phones
  tablet: 768,      // ≤767px: Tablets in portrait
  desktop: 992,     // ≤991px: Tablets in landscape
  large: 1200       // ≤1199px: Small desktops
};

/**
 * Helper function to check if current size is mobile
 */
export function isMobile(width) {
  return width <= breakpoints.tablet;
}

/**
 * Helper function to check if current size is tablet
 */
export function isTablet(width) {
  return width > breakpoints.mobile && width <= breakpoints.desktop;
}

export default useWindowSize;

